import _defineProperty from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Matrix\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import { isArray } from 'vega-util';
import { FACET_CHANNELS } from '../../channel';
import { vgField } from '../../channeldef';
import { HEADER_LABEL_PROPERTIES, HEADER_LABEL_PROPERTIES_MAP, HEADER_TITLE_PROPERTIES, HEADER_TITLE_PROPERTIES_MAP } from '../../header';
import { isSortField } from '../../sort';
import { isFacetMapping } from '../../spec/facet';
import { contains, keys } from '../../util';
import { defaultLabelAlign, defaultLabelBaseline } from '../axis/properties';
import { formatSignalRef } from '../common';
import { sortArrayIndexField } from '../data/calculate';
import { isFacetModel } from '../model';
import { getHeaderChannel, getHeaderProperties, getHeaderProperty } from './common';
import { HEADER_TYPES } from './component'; // TODO: rename to assembleHeaderTitleGroup

export function assembleTitleGroup(model, channel) {
  var title = model.component.layoutHeaders[channel].title;
  var config = model.config ? model.config : undefined;
  var facetFieldDef = model.component.layoutHeaders[channel].facetFieldDef ? model.component.layoutHeaders[channel].facetFieldDef : undefined;

  var _getHeaderProperties = getHeaderProperties(['titleAnchor', 'titleAngle', 'titleOrient'], facetFieldDef, config, channel),
      titleAnchor = _getHeaderProperties.titleAnchor,
      titleAngle = _getHeaderProperties.titleAngle,
      titleOrient = _getHeaderProperties.titleOrient;

  var headerChannel = getHeaderChannel(channel, titleOrient);
  return {
    name: "".concat(channel, "-title"),
    type: 'group',
    role: "".concat(headerChannel, "-title"),
    title: Object.assign({
      text: title
    }, channel === 'row' ? {
      orient: 'left'
    } : {}, {
      style: 'guide-title'
    }, defaultHeaderGuideBaseline(titleAngle, headerChannel), defaultHeaderGuideAlign(headerChannel, titleAngle, titleAnchor), assembleHeaderProperties(config, facetFieldDef, channel, HEADER_TITLE_PROPERTIES, HEADER_TITLE_PROPERTIES_MAP))
  };
}
export function defaultHeaderGuideAlign(headerChannel, angle) {
  var anchor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'middle';

  switch (anchor) {
    case 'start':
      return {
        align: 'left'
      };

    case 'end':
      return {
        align: 'right'
      };
  }

  var align = defaultLabelAlign(angle, headerChannel === 'row' ? 'left' : 'top');
  return align ? {
    align: align
  } : {};
}
export function defaultHeaderGuideBaseline(angle, channel) {
  var baseline = defaultLabelBaseline(angle, channel === 'row' ? 'left' : 'top');
  return baseline ? {
    baseline: baseline
  } : {};
}
export function assembleHeaderGroups(model, channel) {
  var layoutHeader = model.component.layoutHeaders[channel];
  var groups = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = HEADER_TYPES[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var headerType = _step.value;

      if (layoutHeader[headerType]) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = layoutHeader[headerType][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var headerCmpt = _step2.value;
            groups.push(assembleHeaderGroup(model, channel, headerType, layoutHeader, headerCmpt));
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return groups;
}

function getSort(facetFieldDef, channel) {
  var sort = facetFieldDef.sort;

  if (isSortField(sort)) {
    return {
      field: vgField(sort, {
        expr: 'datum'
      }),
      order: sort.order || 'ascending'
    };
  } else if (isArray(sort)) {
    return {
      field: sortArrayIndexField(facetFieldDef, channel, {
        expr: 'datum'
      }),
      order: 'ascending'
    };
  } else {
    return {
      field: vgField(facetFieldDef, {
        expr: 'datum'
      }),
      order: sort || 'ascending'
    };
  }
}

export function assembleLabelTitle(facetFieldDef, channel, config) {
  var _getHeaderProperties2 = getHeaderProperties(['format', 'labelAngle', 'labelAnchor', 'labelOrient'], facetFieldDef, config, channel),
      format = _getHeaderProperties2.format,
      labelAngle = _getHeaderProperties2.labelAngle,
      labelAnchor = _getHeaderProperties2.labelAnchor,
      labelOrient = _getHeaderProperties2.labelOrient;

  var headerChannel = getHeaderChannel(channel, labelOrient);
  return Object.assign({
    text: formatSignalRef(facetFieldDef, format, 'parent', config)
  }, channel === 'row' ? {
    orient: 'left'
  } : {}, {
    style: 'guide-label',
    frame: 'group'
  }, defaultHeaderGuideBaseline(labelAngle, headerChannel), defaultHeaderGuideAlign(headerChannel, labelAngle, labelAnchor), assembleHeaderProperties(config, facetFieldDef, channel, HEADER_LABEL_PROPERTIES, HEADER_LABEL_PROPERTIES_MAP));
}
export function assembleHeaderGroup(model, channel, headerType, layoutHeader, headerCmpt) {
  if (headerCmpt) {
    var title = null;
    var facetFieldDef = layoutHeader.facetFieldDef;
    var config = model.config ? model.config : undefined;

    if (facetFieldDef && headerCmpt.labels) {
      var _getHeaderProperties3 = getHeaderProperties(['labelOrient'], facetFieldDef, config, channel),
          labelOrient = _getHeaderProperties3.labelOrient; // Include label title in the header if orient aligns with the channel


      if (channel === 'row' && !contains(['top', 'bottom'], labelOrient) || channel === 'column' && !contains(['left', 'right'], labelOrient)) {
        title = assembleLabelTitle(facetFieldDef, channel, config);
      }
    }

    var isFacetWithoutRowCol = isFacetModel(model) && !isFacetMapping(model.facet);
    var axes = headerCmpt.axes;
    var hasAxes = axes && axes.length > 0;

    if (title || hasAxes) {
      var sizeChannel = channel === 'row' ? 'height' : 'width';
      return Object.assign({
        name: model.getName("".concat(channel, "_").concat(headerType)),
        type: 'group',
        role: "".concat(channel, "-").concat(headerType)
      }, layoutHeader.facetFieldDef ? {
        from: {
          data: model.getName(channel + '_domain')
        },
        sort: getSort(facetFieldDef, channel)
      } : {}, hasAxes && isFacetWithoutRowCol ? {
        from: {
          data: model.getName("facet_domain_".concat(channel))
        }
      } : {}, title ? {
        title: title
      } : {}, headerCmpt.sizeSignal ? {
        encode: {
          update: _defineProperty({}, sizeChannel, headerCmpt.sizeSignal)
        }
      } : {}, hasAxes ? {
        axes: axes
      } : {});
    }
  }

  return null;
}
var LAYOUT_TITLE_BAND = {
  column: {
    start: 0,
    end: 1
  },
  row: {
    start: 1,
    end: 0
  }
};
export function getLayoutTitleBand(titleAnchor, headerChannel) {
  return LAYOUT_TITLE_BAND[headerChannel][titleAnchor];
}
export function assembleLayoutTitleBand(headerComponentIndex, config) {
  var titleBand = {};
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = FACET_CHANNELS[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var channel = _step3.value;
      var headerComponent = headerComponentIndex[channel];

      if (headerComponent && headerComponent.facetFieldDef) {
        var _getHeaderProperties4 = getHeaderProperties(['titleAnchor', 'titleOrient'], headerComponent.facetFieldDef, config, channel),
            titleAnchor = _getHeaderProperties4.titleAnchor,
            titleOrient = _getHeaderProperties4.titleOrient;

        var headerChannel = getHeaderChannel(channel, titleOrient);
        var band = getLayoutTitleBand(titleAnchor, headerChannel);

        if (band !== undefined) {
          titleBand[headerChannel] = band;
        }
      }
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  return keys(titleBand).length > 0 ? titleBand : undefined;
}
export function assembleHeaderProperties(config, facetFieldDef, channel, properties, propertiesMap) {
  var props = {};
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = properties[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var prop = _step4.value;

      if (!propertiesMap[prop]) {
        continue;
      }

      var value = getHeaderProperty(prop, facetFieldDef, config, channel);

      if (value !== undefined) {
        props[propertiesMap[prop]] = value;
      }
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }

  return props;
}